import React from "react";
import "./index.css";
import { QRCodeCanvas } from "qrcode.react";
import IconTearDropButton from "../../_utils/CommonButtons/IconTearDropButton";
import { IntervalConfiguration } from "../../../utils/configurationProvider";
import SVGComponent from "../../_utils/SVGComponent";
import ICONS from "../../../assets/Icons";

const TotpScanner = ({
  hashKey,
  isQrScanned,
  setIsQrScanned,
  setOpen,
  tooltipText,
  setTooltipText,
}) => {
  const handleCopy = () => {
    navigator.clipboard
      .writeText(hashKey?.key)
      .then(() => {
        setTooltipText("Copied!");
        setOpen(true);

        setTimeout(() => {
          setOpen(false);
          setTooltipText("Click to copy");
        }, IntervalConfiguration.intervalExtraLarge);
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <div className="totp-top-main">
      <div className="divide-totp">
        <div className="totp-scanner-left">
          <h4 className="totp-scanner-left-1">
            Scan QR Code Or Enter The Passkey
          </h4>
          <p className="totp-scanner-left-2">
            Use the authenticator app to scan the QR code shown below, or
            manually enter the passkey into the app.
          </p>
          <p className="totp-scanner-left-3">
            Note: If you want to register an authenticator across several
            devices, scan or enter the passkey in each app simultaneously.
          </p>
          <div className="totp-scanner-left-4">
            <div className="totp-scanner-left-4-qrcode">
              <h4>Scan QR code on authenticator app</h4>
              <div className="totp-scanner-left-4-qrcode-scanner-main">
                <div className="totp-scanner-left-4-qrcode-scanner">
                  <QRCodeCanvas
                    value={`otpauth://totp/Xpentra:${hashKey?.email}?secret=${hashKey?.key}&issuer=Xpentra&digits=6`}
                    size={90}
                  />
                </div>
              </div>
            </div>
            <h4>OR</h4>
            <div className="flex flex-col w-full justify-between bg-primary-nav gap-gap-sm py-padding-sm px-padding-md rounded-border-radius-md relative">
              <p className="text-font-xs font-semibold text-text-secondary">
                Copy passkey
              </p>
              <div className="flex w-full justify-between bg-primary-nav">
                <div className="top-top-base right-right-base absolute">
                  <IconTearDropButton
                    btnType="button"
                    handleFunction={handleCopy}
                    isDisabled={false}
                    isLoading={false}
                    title={tooltipText}
                    enabledBgColor={"var(--primary-nav-act)"}
                    icon={ICONS?.COPY}
                    hoverOption="white"
                  />
                </div>

                <p className="text-font-xs text-text-primary font-semibold">
                  {hashKey?.key}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="divide-totp">
        <div className="totp-scanner-right">
          <SVGComponent
            url={ICONS?.SCAN_GRAPHICS}
            height={"var(--graphic-square-height-md)"}
            width={"var(--graphic-width-md)"}
          />
          <div
            className="totp-scanner-right-button"
            onClick={() => {
              setIsQrScanned(!isQrScanned);
            }}
          >
            <img
              src={
                isQrScanned === true
                  ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                  : ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE
              }
              alt=""
            />
            <div className="totp-scanner-right-button-info">
              <h4>Confirm Action</h4>
              <p>I have scanned QR code/entered the passkey.</p>
            </div>
          </div>
        </div>
        <div className="h-pagination-height"></div>
      </div>
    </div>
  );
};

export default TotpScanner;
